export const ChangeDepartmentModal: string = 'ChangeDepartmentModal';
